import SearchAutocompleteInput from '../../../Inputs/CustomInputs/SearchAutocompleteInput';
import { Button } from '@mui/material';
import classes from '../../../../../components/UI/Inputs/CustomInputs.module.css';
import Strings from '../../../../../resources/Strings';
import Icons from '../../../../../resources/icons/Icons';
import { INPUTS_PROPS } from '../../../../../enums/Enums';
import { ListItem } from '../../../../../entities/UIEntities/ListItem';
import AllocationCard from '../../../Cards/AllocationCard/AllocationCard';
import ScanFobInput from '../../../Inputs/ScanWithFobsInputs/ScanFobInput';
import { useSelector } from "react-redux";

const AddParkerToAllocationInfoStep = (props) => {
  const isFobsSupported = props.site.isFobsSupported;

  let parkersList = useSelector((state) => state.allocations.allocations)
    .map((allocation) => allocation.parker)
    .filter((parker) =>
      // filters parkersList selection by selected siteId && userTypeId (from userType step) && 
      // excludes already assigned parker from searchParker selection
      // filters seeing parkers from the same selected userTypes 
      // exclude parkers that are not from the same selected userType
      parker.utronUser.userSites.some((us) => us.siteId === props.site?.id) && // filter by selected userSite
      parker.utronUser.userToUserTypes.some((ut) => ut.userTypeId === props.userTypeId) && // filter by selected userType
      !props.assignedParkers.some(assigned => assigned.utronUser.id === parker.utronUser.id) //&& // exclude already assignedParkers
      //props.foundedExistingParker?.id !== parker.utronUser.id // on existing case: exclude founded parker (parker that is founded from the phone search)
    ) 
    .map(
      (parker) =>
        new ListItem(
          parker.utronUser.id,
          `${parker.utronUser?.firstName} ${parker.utronUser?.lastName}`,
          parker
        )
    );
  parkersList = parkersList.filter(
    (item, index) =>
      parkersList.findIndex((parker) => item.id === parker.id) === index
  ); // distinct array


  return (
    <>
        {props?.selectedParker === null ? (
        <>
          <Button onClick={props?.handleCloseAddParkerInputs}>
              <img src={Icons.DELETE_ITEM_4} />
          </Button>
          <div className={classes.search}>
            <SearchAutocompleteInput 
              label={Strings.INPUT_LABELS.SEARCH_PARKER}
              id={INPUTS_PROPS.SELECTED_PARKER}
              onChange={props?.handleSelectChange}
              list={parkersList}
              value={props?.selectedParker ? `${props?.selectedParker.utronUser.firstName} ${props?.selectedParker.utronUser.lastName}` : ""}
              defaultValue={""}
              startAdornment={<img src={Icons.SEARCH} />}
            />
          </div>
        </>
        ) : 
        (isFobsSupported &&
         <div>
          <AllocationCard
              tokenId={props.tokenId} 
              name={`${props?.selectedParker?.utronUser?.firstName} ${props?.selectedParker?.utronUser?.lastName}`}
              //fob={props.fob}
              isActive={props.isActive}
              image={props?.selectedParker?.utronUser?.image}
              site={props?.site} // has if fob supported
              // openFobActivationModal={openFobActivationModal}
              // targetAllocation={targetAllocation}
              // openRemoveParkerAllocationModal={openRemoveParkerAllocationModal}
              // showMenuItems={true}
              
              // showFobScannerInput={showFobScannerInput}
              // fobInputValue={fob}
              // handleChange={handleChange}
              // handleCloseFobInput={handleCloseFobInput}
              // handleConfirmScanFob={handleConfirmScanFob}
            ></AllocationCard>
            <ScanFobInput 
              label={Strings.SCAN_NEW_FOB_BUTTON}
              id={INPUTS_PROPS.FOB}
              value={/*fob*/ props.fob}
              onChange={props?.handleChange} 
              handleClose={props?.handleCloseAddParkerInputs} 
              handleSkip={props?.handleSkip}
              //isStepSubmitted={props.isStepSubmitted}
              handleConfirmScanFob={props?.handleConfirmAddParkerScanFob} 
              //handleError={false}
              //hasError={false}
              //errorMessage=""
              //hasError={hasLocalErrors}
              //errorMessage={hasLocalErrors ? Strings.INPUT_ERROR_MESSAGES.FOB_ALREADY_EXISTS : ""}
            />
        </div>)}
    </>
  )
}

export default AddParkerToAllocationInfoStep;